import React, { type CSSProperties, type HTMLAttributes, type ReactElement } from 'react';

import classnames from 'classnames';

import { SKELETON_LOADING } from '../../../dataTestIds';

import * as Primitives from './Skeleton.parts';

import styles from './Skeleton.module.scss';

export type SkeletonProps = Pick<CSSProperties, 'width' | 'height'> &
    HTMLAttributes<HTMLDivElement>;

const SkeletonRoot = ({
    width,
    height,
    className,
    style,
    children,
    ...rest
}: SkeletonProps): ReactElement => {
    return (
        <div
            className={classnames(styles.container, className)}
            data-testid={SKELETON_LOADING}
            style={{ width, height, ...style }}
            aria-hidden="true"
            inert={'true' as never}
            {...rest}
        >
            <div className={styles.mask} />
            {children}
        </div>
    );
};

type SkeletonCompound = typeof SkeletonRoot & typeof Primitives;

export const Skeleton = Object.assign(SkeletonRoot, Primitives) as SkeletonCompound;
